var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconLibrary = function SvgIconLibrary(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 43.125H18.3125C17.8152 43.125 17.3383 42.9275 16.9867 42.5758C16.635 42.2242 16.4375 41.7473 16.4375 41.25V21.5625C16.4375 21.0652 16.635 20.5883 16.9867 20.2367C17.3383 19.885 17.8152 19.6875 18.3125 19.6875H19.25C19.7473 19.6875 20.2242 19.885 20.5758 20.2367C20.9275 20.5883 21.125 21.0652 21.125 21.5625V41.25C21.125 41.7473 20.9275 42.2242 20.5758 42.5758C20.2242 42.9275 19.7473 43.125 19.25 43.125ZM29.5625 25.3125C29.5625 24.8152 29.365 24.3383 29.0133 23.9867C28.6617 23.635 28.1848 23.4375 27.6875 23.4375H23.9375C23.4402 23.4375 22.9633 23.635 22.6117 23.9867C22.26 24.3383 22.0625 24.8152 22.0625 25.3125V26.9531C22.0625 27.0153 22.0872 27.0749 22.1311 27.1189C22.1751 27.1628 22.2347 27.1875 22.2969 27.1875H29.3281C29.3903 27.1875 29.4499 27.1628 29.4939 27.1189C29.5378 27.0749 29.5625 27.0153 29.5625 26.9531V25.3125ZM22.0625 41.25C22.0625 41.7473 22.26 42.2242 22.6117 42.5758C22.9633 42.9275 23.4402 43.125 23.9375 43.125H27.6875C28.1848 43.125 28.6617 42.9275 29.0133 42.5758C29.365 42.2242 29.5625 41.7473 29.5625 41.25V39.4922C29.5625 39.4611 29.5502 39.4313 29.5282 39.4093C29.5062 39.3873 29.4764 39.375 29.4453 39.375H22.1797C22.1486 39.375 22.1188 39.3873 22.0968 39.4093C22.0748 39.4313 22.0625 39.4611 22.0625 39.4922V41.25Z",
    fill: "url(#paint0_linear_16_7959)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4453 29.0625H22.1797C22.115 29.0625 22.0625 29.115 22.0625 29.1797V37.3828C22.0625 37.4475 22.115 37.5 22.1797 37.5H29.4453C29.51 37.5 29.5625 37.4475 29.5625 37.3828V29.1797C29.5625 29.115 29.51 29.0625 29.4453 29.0625Z",
    fill: "url(#paint1_linear_16_7959)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.25 43.125H32.375C31.8777 43.125 31.4008 42.9275 31.0492 42.5758C30.6975 42.2242 30.5 41.7473 30.5 41.25V18.75C30.5 18.2527 30.6975 17.7758 31.0492 17.4242C31.4008 17.0725 31.8777 16.875 32.375 16.875H34.25C34.7473 16.875 35.2242 17.0725 35.5758 17.4242C35.9275 17.7758 36.125 18.2527 36.125 18.75V41.25C36.125 41.7473 35.9275 42.2242 35.5758 42.5758C35.2242 42.9275 34.7473 43.125 34.25 43.125ZM44.5561 41.1006L42.6676 21.1787C42.5809 20.2617 41.675 19.5967 40.6443 19.6957L38.7781 19.8715C37.7475 19.9693 36.9822 20.792 37.0689 21.709L38.9574 41.6309C39.0441 42.5479 39.95 43.2129 40.9807 43.1139L42.8469 42.9381C43.8775 42.8402 44.6428 42.0176 44.5561 41.1006Z",
    fill: "url(#paint2_linear_16_7959)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_7959",
    x1: 7.21546,
    y1: 31.4062,
    x2: 32.4293,
    y2: 31.4062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3499FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3985"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_7959",
    x1: 16.7928,
    y1: 33.2812,
    x2: 31.2007,
    y2: 33.2812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3499FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3985"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16_7959",
    x1: 20.6191,
    y1: 30,
    x2: 47.6344,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3499FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3985"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconLibrary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/IconLibrary.e755544766090eb8e0f9ce2253860a72.blank.svg";